import React, { useState, useEffect, useRef } from "react";
import styles from "./TemplateHero27.module.css";

const TemplateHero27 = ({ branding, heroData }) => {
  const [current, setCurrent] = useState(0);
  const [mouse, setMouse] = useState({ x: 0, y: 0 });
  const [entering, setEntering] = useState(true);
  const rootRef = useRef(null);

  const slides = heroData?.slides || [];

  useEffect(() => {
    if (slides.length <= 1) return;

    const t = setInterval(() => {
      setEntering(false);

      setTimeout(() => {
        setCurrent((p) => (p + 1) % slides.length);
        setEntering(true);
      }, 500);
    }, 5500);

    return () => clearInterval(t);
  }, [slides.length]);

  const handleMouse = (e) => {
    if (!rootRef.current) return;

    const r = rootRef.current.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;

    setMouse({ x, y });
  };

  if (!slides.length) return null;

  const floatCards = [
    { top: "10%", left: "5%", w: "22%", h: "28%", depth: 1.8, rot: "-4deg" },
    { top: "55%", left: "3%", w: "19%", h: "24%", depth: 1.4, rot: "3.5deg" },
    { top: "8%", right: "4%", w: "21%", h: "26%", depth: 1.6, rot: "3deg" },
    { top: "58%", right: "5%", w: "20%", h: "25%", depth: 1.2, rot: "-2.5deg" },
  ];

  return (
    <div
      className={styles.root}
      ref={rootRef}
      onMouseMove={handleMouse}
    >
      <div
        className={`${styles.bg} ${entering ? styles.bgIn : styles.bgOut}`}
        style={{ backgroundImage: `url('${slides[current].image}')` }}
      />

      <div className={styles.grain} />

      {/* Top Bar */}
      <div className={styles.topbar}>
        <span className={styles.brand}>
          {branding?.companyName || "Travel Co."}
        </span>

        <div className={styles.sep} />

        <span className={styles.brand}>
          Premium Journeys
        </span>
      </div>

      {/* Floating Cards */}
      {floatCards.map((pos, i) => {
        const slideIdx = i % slides.length;

        const tx = mouse.x * pos.depth * 18;
        const ty = mouse.y * pos.depth * 14;

        const style = {
          backgroundImage: `url('${slides[slideIdx].image}')`,
          width: pos.w,
          height: pos.h,
          transform: `rotate(${pos.rot}) translate(${tx}px, ${ty}px)`,
          ...(pos.right
            ? { right: pos.right, top: pos.top }
            : { left: pos.left, top: pos.top }),
        };

        return (
          <div key={i} className={styles.card} style={style}>
            <div className={styles.cardOverlay} />

            <div className={styles.cardCaption}>
              <div className={styles.cardNum}>
                0{slideIdx + 1}
              </div>

              <div className={styles.cardName}>
                {slides[slideIdx].title}
              </div>
            </div>
          </div>
        );
      })}

      {/* Center Panel */}
      <div className={styles.center}>
        <span className={styles.overline}>
          {branding?.companyName || "Luxury Travel"}
        </span>

        <h1
          className={`${styles.title} ${
            entering ? styles.titleIn : styles.titleOut
          }`}
        >
          {slides[current].title}
        </h1>

        <div className={styles.divider} />

        <p className={styles.sub}>
          {slides[current].subtitle}
        </p>

        <div className={styles.buttons}>
          <button className={styles.btnGold}>
            Explore Packages
          </button>

          <button className={styles.btnGlass}>
            Our Story
          </button>
        </div>

        <div className={styles.dots}>
          {slides.map((_, i) => (
            <div
              key={i}
              className={`${styles.dot} ${
                i === current ? styles.activeDot : ""
              }`}
              onClick={() => setCurrent(i)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TemplateHero27;